<template>
  <div>
    <v-tooltip top allow-overflow :disabled="!tooltip">
      <v-btn @click="copy()" flat slot="activator">
        <v-icon
          id="absolutePathIcon"
          ref="absolutePathIcon"
          v-html="icon"
          color="black"
          size="16"
        ></v-icon>
        <input
          type="text"
          class="hidden"
          ref="absolutePath"
          v-bind:value="absolutePath"
        />
      </v-btn>
      <span>Click to copy a link to this post to your clipboard.</span>
    </v-tooltip>
    <!-- <a v-bind:href="absolutePath" target="_blank" id="absolutePath">{{ absolutePath }}</a> -->
  </div>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";

div {
  display: flex !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

span {
  color: $font-color;
  font-weight: normal;

  .like,
  .like > * {
    color: white;
  }
}

.v-btn {
  font-weight: normal;
  min-width: 3em !important;
  justify-content: left;
  text-align: left;

  ::v-deep .v-btn__content {
    margin-left: -75%;
  }
}

.v-tooltip__content {
  * {
    color: white;
  }
}
</style>

<script>
export default {
  props: ["cardId", "groupId"],
  data() {
    return {
      tooltip: true,
      tooltipBreakpoint: 420,
      icon: "far fa-copy"
    };
  },
  computed: {
    path() {
      return "/group/" + this.groupId + "/card/" + this.cardId;
    },
    absolutePath() {
      return window.location.origin + this.path;
    },
    smallWidth() {
      return this.isSmallWidth();
    }
  },
  methods: {
    isSmallWidth() {
      return this.getScreenWidth() < this.tooltipBreakpoint;
    },
    // https://github.com/johndatserakis/vue-screen-size/blob/develop/src/vue-screen-size.js.
    getScreenWidth() {
      return (
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      );
    },
    copy() {
      const relevantInput = this.$refs.absolutePath;
      relevantInput.select();
      relevantInput.setSelectionRange(0, 999999);
      // Documentation says to do this but it doesn't fully work.
      navigator.clipboard.writeText(relevantInput.value);

      // Documentation says this is the "old way", but it does seem to work.
      document.execCommand("copy");

      this.$store.commit("updateMessage", {
        message: relevantInput.value + " has been copied to your clipboard.",
        snackbar: true
      });
    }
  },
  mounted() {
    this.tooltip = !this.isSmallWidth();
    window.addEventListener("resize", () => {
      this.tooltip = !this.isSmallWidth();
    });
  }
};
</script>
